import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
  email: string;
  isOtpVerified: boolean;
  userPassword: string | null;
  loading: boolean;
  referrer: string | null;
  setEmail: (email: string) => void;
  setOtpVerified: (isVerified: boolean) => void;
  setUserPassword: (password: string | null) => void;
  setLoading: (loading: boolean) => void;
  setReferrer: (referrer: string | null) => void;
}

const useAppState = create<AppState>()(
  persist(
    (set) => ({
      email: '',
      isOtpVerified: false,
      userPassword: null,
      loading: false,
      referrer: null,
      setEmail: (email) => set({ email }),
      setOtpVerified: (isVerified) => set({ isOtpVerified: isVerified }),
      setUserPassword: (password) => set({ userPassword: password }),
      setLoading: (loading) => set({ loading }),
      setReferrer: (referrer) => set({ referrer }),
    }),
    {
      name: 'app-state', // Key to store the state in localStorage
      storage: {
        getItem: (name) => {
          const item = localStorage.getItem(name);
          return item ? JSON.parse(item) : null;
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
        },
      }, // Use a custom localStorage adapter to persist the state
    }
  )
);

export default useAppState;
